module.exports = __webpack_public_path__ + "assets/img/latest_release.96e530f0.svg";